// extracted by mini-css-extract-plugin
export default {"swiper":"product-slider_swiper__2zNvv","swiperSlide":"product-slider_swiperSlide__9RXwM","swiperPagination":"product-slider_swiperPagination__7DXcL"};